<template>
    <!--  <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">-->
    <div style="margin-top:0px;" :class="$i18n.locale=='العربية'?'rtlclass':'ltrclass'">
        <Header/>

        <div
            :class="$i18n.locale=='العربية'?'FrameWork__PageWrapper-v8gq48-13 eRmiUC':'FrameWork__PageWrapper-v8gq48-13 obiMX'">
            <section class="style__SpotlightInnerWrap-sc-1qapdh8-0 kKgHVc">
                <div class="spotlight">
                    <div class="style__SpotlightItemStyled-vo40go-0 cDscbW">
                        <figure>
                            <div class=" gatsby-image-wrapper" style="position:relative;overflow:hidden">
                                <div aria-hidden="true" style="width:100%;padding-bottom:49.5%"></div>

                                <picture><img v-if="this.pagedata"
                                              :src="this.serverurl+'/public/pagebanners/'+pagedata.pagebanner"
                                              alt=""
                                              style="position:absolute;top:0;left:0;opacity:1;width:100%;height:100%;object-fit:cover;object-position:center"/>
                                </picture>

                            </div>
                        </figure>
                       <div class="spotlight__info" :style="$i18n.locale == 'العربية' ?'float:right;width:100%;padding-left:8%;padding-right:8%':'float:left;margin-left:3%;width:100%;padding-left:8%;padding-right:8%'">
                            <div class="react-reveal"
                                 style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">
                                <div class="style__SectionTitleStyled-d40vxv-0 kcvceY" :style="$i18n.locale == 'العربية' ?'float:right;margin-right:3%;width: 50%;':'float:left;margin-left:3%;width: 50%;'">
                                    <h2 v-if="pagedata" :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;'">
<!--                                        {{-->
<!--                                            $i18n.locale == 'en' ? pagedata.page_entitle : $i18n.locale == 'العربية' ? pagedata.page_artitle : $i18n.locale == '中文' ? pagedata.page_chtitle : pagedata.page_frtitle-->
<!--                                        }}-->
                                        {{
                                            $i18n.locale == 'en' ? analysisdata.titleen : $i18n.locale == 'العربية' ? analysisdata.titlear : $i18n.locale == '中文' ? analysisdata.titlech : analysisdata.titlefr
                                        }}
                                    </h2>
                                </div>
                            </div>
                              <div class="btn_wrap" :style="$i18n.locale == 'العربية' ?'width:100%;float:right!important;margin-right:3%!important':'width:100%;float:left;margin-left:3%!important'">

                                <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/demoaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                        {{
                                         $i18n.locale == 'en' ? 'Open Demo Account' : $i18n.locale == 'العربية' ? 'فتح حساب تجريبي' : $i18n.locale == '中文' ? '开设模拟账户':$i18n.locale=='Русский'?'Открыть демо-аккаунт' : 'Ouvrir un compte Dé'

                                        }}

                                        </span></a></div>
                                </div>
                                 <div class="react-reveal" :style="$i18n.locale == 'العربية' ?'float:right;animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;':'animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;'">
                                    <div class="style__ButtonWrap-kitu94-0 hqzysg" style="width: 100%!important;text-align: center!important;"><a style=""
                                        href="https://marketequityinc.com/custom/liveaccountlinks.php" target="_blank"
                                        rel="noopener noreferrer"><span>
                                            {{
                                            $i18n.locale == 'en' ? 'Open Live Account' : $i18n.locale == 'العربية' ? 'فتح حساب حقيقي' : $i18n.locale == '中文' ? '开设真实账户':$i18n.locale=='Русский'?'Открыть реальный аккаунт': 'Ouvrir un compte Réel'
                                }}
                                        </span></a></div>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </section>


           
            <section>

                <div class="FrameWork__ContainerFluidStyled-v8gq48-1 kNCxBo" :style="$i18n.locale == 'العربية' ? 'text-align: right;font-family: Cairo,sans-serif !important;' :'font-family: Comfortaa!important;'">

                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                        <div class="react-reveal"
                             style="animation-fill-mode: both; animation-duration: 1000ms; animation-delay: 0ms; animation-iteration-count: 1; opacity: 1; animation-name: slideInUp;">


                            <div class="FrameWork__ContentData-v8gq48-10 ZBsdR" :style="$i18n.locale == 'العربية' ?'text-align: right':'text-align: left'">
                                <div class="FrameWork__Row-v8gq48-2 VIUMD" style="padding-right:10%;padding-left:10%">
                                    <div class="FrameWork__ColSm-v8gq48-3 dIoETn">
                                        <h2 :style="$i18n.locale == 'العربية' ? 'text-transform: uppercase;font-size: 26px;font-weight: 400;font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;text-transform: uppercase;font-size: 26px;font-weight: 400'" v-html="$i18n.locale == 'en' ? analysisdata.descriptionen : $i18n.locale == 'العربية' ? analysisdata.descriptionar : $i18n.locale == '中文' ? analysisdata.descriptionch : analysisdata.descriptionfr">
                                        {{
                                            $i18n.locale == 'en' ? analysisdata.descriptionen : $i18n.locale == 'العربية' ? analysisdata.descriptionar : $i18n.locale == '中文' ? analysisdata.descriptionch : analysisdata.descriptionfr
                                        }}</h2>
                                        
                                        <div><p v-if="type=='currency' && analysisdata.chart"><img class="alignnone size-full wp-image-48749"
                                                     :src="this.serverurl+'/public/currencycharts/'+analysisdata.chart"
                                                     alt=""

                                                     sizes="(max-width: 360px) 350px, (max-width: 767px) 765px, 1002px"
                                                     width="1002" height="535"></p>
                                            <p v-if="type=='crosses'"><img class="alignnone size-full wp-image-48749"
                                                     :src="this.serverurl+'/public/crossescharts/'+analysisdata.chart"
                                                     alt=""

                                                     sizes="(max-width: 360px) 350px, (max-width: 767px) 765px, 1002px"
                                                     width="1002" height="535"></p>
                                            <p :style="$i18n.locale == 'العربية' ? 'font-family: Cairo, sans-serif !important;' :'font-family:Roboto,sans-serif;'"  v-html="$i18n.locale == 'en' ? analysisdata.contenten : $i18n.locale == 'العربية' ? analysisdata.contentar : $i18n.locale == '中文' ? analysisdata.contentch : analysisdata.contentfr">{{ $i18n.locale == 'en' ? analysisdata.contenten : $i18n.locale == 'العربية' ? analysisdata.contentar : $i18n.locale == '中文' ? analysisdata.contentch : analysisdata.contentfr }}</p>
                                            <p>&nbsp;</p>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>

                </div>


            </section>


          

            <Footer/>
        </div>

    </div>

</template>

<script>
import Header from '@/components/header.vue'
import Footer from '@/components/footer.vue'

export default {
    name: 'page',
    data() {
        return {
            pagedata: '',
            analysisdata: '',
            type: ''


        }
    },
    components: {
        Header,
        Footer
    },
    beforeMount() {
        this.exampleModalCenter = false;
        var pathvalues = (this.$route.path).split("/");


        if (pathvalues[1] == 'ar') {
            this.$i18n.locale = 'العربية';
        }
        if (pathvalues[1] == 'ch') {
            this.$i18n.locale = '中文';
        }
        if (pathvalues[1] == 'fr') {
            this.$i18n.locale = 'Français';
        }

        this.pagenameroute = pathvalues[4];

        this.loadanalysisdata(this.pagenameroute, pathvalues[3])
    },

    methods: {

        loadanalysisdata(analysisid, type) {
            this.$axios.get("loadtechanalysis", {
                params: {
                    analysisid: analysisid,
                    type: type
                }
            })
                .then(res => {
                    if (res) {
                        console.log(res)
                        this.pagedata = res.data.pagedata[0];
                        this.analysisdata = res.data.analysisone;
                        this.type=res.data.type;


                    }
                });
        },

    }
}
</script>

<style>
p
{
line-height: 4!important;
}
body, div, form, input, select, p
{
    font-family: inherit !important;

}
.rtlclass {
    direction: rtl !important;
    font-family: Cairo,sans-serif !important;


}
th {
    background-color: #005060;
    color: #ffffff;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

.carousel {
    background: #2f4357;
    margin-top: 20px;
}

.carousel-item {
    text-align: center;
    min-height: 280px; /* Prevent carousel from being distorted if for some reason image doesn't load */
}

.rtlclass {
    direction: rtl !important;


}

.ltrclass {
    direction: ltr !important;
}

select {
    width: 150px;
    line-height: 49px;
    height: 38px;
    font-size: 22px;
    outline: 0;
    margin-bottom: 15px;
}

.p {
    animation-fill-mode: both;
    animation-duration: 1000ms;
    animation-delay: 0ms;
    animation-iteration-count: 1;
    opacity: 1;
    animation-name: slideInUp;
}

#tabela th, td {
    padding: 30px;
}

tabela tr:nth-child(even) {
    background-color: #f2f2f2;
}

a:hover, a:focus {
    text-decoration: none;
    outline: none;
}

#accordion .panel {
    border: none;
    border-radius: 3px;
    box-shadow: none;
    margin-bottom: 15px;
}

#accordion .panel-heading {
    padding: 0;
    border: none;
    border-radius: 3px;
}

#accordion .panel-title a {
    display: block;
    padding: 12px 15px 12px 50px;
    background: #ffffff;
    border: 1px solid #c3c3c3;
    border-radius: 3px;
    font-size: 22px;
    font-weight: bold;
    color: #005060;
    text-shadow: 1px 1px 1px #fff;
    position: relative;

}

#accordion .panel-title a:before {
    content: "-";
    font-family: "Font Awesome 5 Free";
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    background: #929191;
    font-size: 12px;
    font-weight: 900;
    color: #fdfbfb;
    text-align: center;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    text-shadow: none;
    position: absolute;
    top: 8px;
    left: 15px;
}

#accordion .panel-title a.collapsed:before {
    content: "+";
}

#accordion .panel-body {
    padding: 10px 15px;
    font-size: 15px;
    color: #222;
    line-height: 27px;
    border: none;
}

#accordion .panel-body p {
    margin-bottom: 0;
}
span,p{
    font-family: "cairo";
}

div > p > p> span > span > span > span > span > span > span > span{
    font-family: "cairo";
}
html body {
 font-family: "cairo";  
}
</style>

